<a
    class="content-list__item content-list__item--simple content-list__link"
    [routerLink]="[companyItem.id]"
>
    <h4 class="content-list__title">{{ companyItem.name }}</h4>
</a>
